import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import BlogLayout from "../../components/BlogLayout";
import logo from "../../assets/logo.svg";
import "./ThoughtBoxPage.css";

const ThoughtBoxPage = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulating data fetch
    const fetchBlog = async () => {
      try {
        // In a real app, this would be an API call
        const mockBlog = {
          title: "What Thought Box's about?",
          publishDate: "March 15, 2024",
          author: {
            name: "Venkatesh",
            image: "/api/placeholder/120/120",
            bio: "AI researcher and technology ethicist with over 10 years of experience in the field. Currently leading research initiatives on responsible AI development.",
            socialLinks: [
              {
                icon: "Twitter Icon",
                url: "https://twitter.com/example",
              },
              {
                icon: "LinkedIn Icon",
                url: "https://linkedin.com/in/example",
              },
            ],
          },
          content: "Venkatesh",
        };
        setBlog(mockBlog);
      } catch (error) {
        console.error("Error fetching blog:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading) {
    return (
      <BlogLayout title="Loading...">
        <div className="loading-container">
          <div className="loading-spinner"></div>
        </div>
      </BlogLayout>
    );
  }

  if (!blog) {
    return (
      <BlogLayout title="Error">
        <div className="error-container">
          <h2 className="error-title">Blog post not found</h2>
          <p className="error-message">
            The requested blog post could not be loaded.
          </p>
        </div>
      </BlogLayout>
    );
  }

  return (
    <BlogLayout title={blog.title}>
      <Helmet>
        <title>What ThoughtBox's about?</title>
        <meta
          name="description"
          content="ThoughtBox is a space for curious minds to explore, learn, and share ideas. It bridges the known and the unknown, encouraging conversations across diverse perspectives."
        />
        <meta property="og:title" content="What ThoughtBox's about?" />
        <meta
          property="og:description"
          content="ThoughtBox is a space for curious minds to explore, learn, and share ideas. It bridges the known and the unknown, encouraging conversations across diverse perspectives."
        />
        <meta property="og:image" content={logo} />
        <meta property="og:url" content="https://thought-box.in/about" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ThoughtBox" />
        <meta
          name="twitter:description"
          content="ThoughtBox is a space for curious minds to explore, learn, and share ideas. It bridges the known and the unknown, encouraging conversations across diverse perspectives."
        />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <article className="article-content">
        <h1 className="article-title">{blog.title}</h1>

        {/* <div className="author-meta">
          <img
            src={blog.author.image}
            alt={blog.author.name}
            className="author-image"
          />
          <div className="author-info">
            <p className="author-name">{blog.author.name}</p>
            <p className="publish-date">{blog.publishDate}</p>
          </div>
        </div> */}

        <div className="article-body">
          <div> Hi !</div>
          <p>
            In the grand journey of life, we are often faced with a multitude of
            paths, each beckoning us with its unique allure. Some roads are
            chosen, leading us down well-trodden trails, while others remain
            untraveled—lingering in the recesses of our minds, haunting our
            thoughts with their untamed possibilities. These unexplored avenues,
            these roads not taken, whisper to us in quiet moments, stirring
            curiosity and wonder.
          </p>
          <p>
            For a decade now, I have walked a chosen path, carving my way
            through the intricacies of my passions and interests. And yet, the
            allure of those untaken roads never faded. At first, it was a
            fleeting thought, a distant echo. But as the years passed, it grew
            into something more—not just an idle curiosity, but a growing
            realization that true growth lies beyond the familiar. I began to
            see that knowledge doesn’t exist in isolation; it thrives where
            different journeys intersect, where perspectives collide, and where
            exploration leads to transformation.
          </p>
          <p>
            The questions began as gentle whispers, then grew louder with time.
            I found myself wondering—not just about the roads I had taken, but
            about the ones I had left behind.
          </p>
          <p>
            Would I always remain a traveler on my own road, or was there a way
            to bridge these paths? How could I seek out those who had walked
            different trails, and in turn, share my own experiences? The thought
            lingered, restless and urgent, until I realized it needed a space to
            take shape—a home where ideas could meet, evolve, and inspire.
          </p>
          <p>
            And so, from the chaos of my musings and the myriad of experiences
            gathered along my journey, Thought Box was born. Every road, whether
            well-traveled or hidden in the shadows, holds a treasure trove of
            insights and inspiration. Here, the roads not taken are no longer
            distant dreams—they are invitations to explore, to learn from those
            who have walked these roads before us, and to share our own
            discoveries with fellow travelers.
          </p>
          <p>
            So, I invite you—not only to explore but to contribute. Share the
            lessons you’ve learned from your own journey. Lend your voice to
            those still searching for direction. Whether you have walked a
            well-worn path or blazed a trail of your own, your wisdom has the
            power to illuminate new possibilities for others.
          </p>
          <p>
            Let’s embark on this journey together, through the crossroads of
            knowledge, experience, and imagination. Welcome to Thought Box,
            where every road is worth exploring—and where every traveler has a
            story to tell.
          </p>
          <div>
            With love,<br></br>
            {blog.content}
          </div>
        </div>
      </article>
    </BlogLayout>
  );
};

export default ThoughtBoxPage;
